export const useLocaleCode = () => useState<string>('localeCode', () => '');